'use client'

import Link from 'next/link'
import { useState, type MouseEvent } from 'react'

import { cn, setCookie } from '@/shared/lib'
import { Icon } from '@/shared/ui'

import { BANNER_COOKIE_VALUE, getExpireTime } from '../lib/slim-banner'

type Props = {
  cookieName: string
  initialVisible: boolean
  url: string
  children: React.ReactNode
}

export const SlimBanner = ({
  cookieName,
  initialVisible,
  url,
  children,
}: Props) => {
  const [isVisible, setIsVisible] = useState(initialVisible)

  const handleClose = (event: MouseEvent) => {
    event.preventDefault()

    setIsVisible(false)
    setCookie(cookieName, BANNER_COOKIE_VALUE, {
      expires: getExpireTime(),
    })
  }

  if (!isVisible) {
    return null
  }

  return (
    <section className={cn('flex h-12')}>
      <Link
        href={url}
        className="relative h-12 grow bg-gray-900"
        target="_blank"
      >
        <div className="absolute top-1/2 left-1/2 my-0 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center space-x-1.5">
          {children}
        </div>
        <button
          className={cn(
            'absolute top-1/2 right-4 -translate-y-1/2',
            'flex h-8 w-8 cursor-pointer items-center justify-center',
          )}
          onClick={handleClose}
          aria-label="하루동안 배너를 표시하지 않음"
        >
          <Icon name="close" size={16} className="text-white" />
        </button>
      </Link>
    </section>
  )
}
